// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { MASTER_PAGE_ON_BREAKPOINT } from './constants';

export function onBreakpoint(broken) {
  return {
    type: MASTER_PAGE_ON_BREAKPOINT,
    broken,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MASTER_PAGE_ON_BREAKPOINT:
      return {
        ...state,
        broken: action.broken,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/master-page/redux/onBreakpoint.js